module.exports = __webpack_public_path__ + "img/1082897204.22f13bd4.png";